import client from "@/services/rest/client"

export function ping() {
  const method = "get"
  const url = "/public/ping"

  return client({ method, url })
}

export function markNotificationAsRead(id) {
  const method = "put"
  const url = `/public/notifications/${id}/read`

  return client({ method, url })
}

export function cancelUserBonus(id) {
  const method = "put"
  const url = `/public/user-bonuses/${id}/cancel`

  return client({ method, url })
}

export function fetchPlayerBets(params) {
  const method = "get"
  const url = "/public/player/bets"

  return client({ method, url, params })
}

export function fetchBillingsCurrencies(params) {
  const method = "get"
  const url = "/public/billings/currencies"

  return client({ method, url, params })
}

export function fetchCryptoDepositInit(data) {
  const method = "post"
  const url = "/public/billings/crypto-deposit-init"

  return client({ method, url, data })
}

export function fetchWithdrawal(data) {
  const method = "post"
  const url = "/public/billings/withdrawal"

  return client({ method, url, data })
}

export function fetchWallets(params) {
  const method = "get"
  const url = "/public/wallets"

  return client({ method, url, params })
}

export function fetchBillingProviders(params) {
  const method = "get"
  const url = "/public/billings"

  return client({ method, url, params })
}
